import { type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  facilityDataDownload: "Analytics.AnalyticsFacilityDataDownload",
  permitDataDownload: "Analytics.AnalyticsPermitDataDownload",
  wellDataDownload: "Analytics.AnalyticsWellDataDownload",
};

export { names as analyticsRouteNames };

const quickBooksRoutes: RouterOptions["routes"] = [
  {
    path: "/analytics",
    component: () => import("@/views/analytics/AnalyticsBase.vue"),
    children: [
      {
        path: "downloadFacilityData",
        name: names.facilityDataDownload,
        meta: { title: "Facility Data Download", hideFilterChange: true },
        component: () => import("@/views/analytics/AnalyticsFacilityDataDownload.vue"),
      },
      {
        path: "downloadPermitData",
        name: names.permitDataDownload,
        meta: { title: "Permit Data Download", hideFilterChange: true },
        component: () => import("@/views/analytics/AnalyticsPermitDataDownload.vue"),
      },
      {
        path: "downloadWellData",
        name: names.wellDataDownload,
        meta: { title: "Well Data Download", hideFilterChange: true },
        component: () => import("@/views/analytics/AnalyticsWellDataDownload.vue"),
      },
    ],
  },
];
export default quickBooksRoutes;
